<template>
                <div>
                        <!-- 轮播图 -->
                        <div class="wrapper">
                                        <swiper :options="swiperOption" class="swiper-container">
                                        <swiper-slide class="swiper-item" v-for="item of list.banner" :key="item.id">
                                          <div class="img_div">
                                                <img class="swiper-img" :src="item.pic" alt="图片集"  />
                                          </div>
                                        </swiper-slide>

                                        <div class="swiper-pagination" slot="pagination" ></div>
                                        </swiper>
                        </div>
                </div>
</template>



<script>
      export default({
        data(){
            return{
            list:{
                banner: [
                // require("@/assets/images/swiper1.jpg"),
                // require("@/assets/images/swiper2.jpg"),
                // require("@/assets/images/swiper3.png")
                ],
            },

                swiperOption: {
                pagination: {
                        el: ".swiper-pagination",
                        clickable: true // 允许点击小圆点跳转
                        },
                autoplay: {
                delay: 2500,
                stopOnLastSlide: false,
                disableOnInteraction: false
                }, //自动播放
                speed: 800, //滑动速度
                setWrapperSize: true,
                observeParents: true,
                paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
                loop: true, //循环
                observer: true,
                autoplayDisableOnInteraction: true //用户操作swiper之后，是否禁止autoplay
                },
          }
         },
         methods:{
                async banner(){
                        var dt = await this.$axios.get('/api/header')
                        dt.data = JSON.parse(dt.data)
                        if (dt.status == 200) {
                                if (dt.data.code !== 0) {
                                        this.$message({
                                        type: 'info',
                                        message: dt.data.msg
                                        });
                                        return;
                                }
                        } else {
                        alert(dt.statusText)
                        return;
                        }
                        // console.log(dt.data.data.banner)
                        this.list.banner = dt.data.data.banner
                }
         },
         created() {
               this.banner()
         }

      })
</script>

<style lang="less" scoped>

              @media (max-width: 480px){
                      .wrapper{
                        height: 160px;
                        .img_div{
                                height: 160px;
                        }
                        .swiper-img{
                                min-height: 160px;     
                        }
                    }
                }

                @media (min-width:480px) and (max-width:2000px){
                        .wrapper{
                                height: 240px;
                                .img_div{
                                        height: 240px;
                                }
                                .swiper-img{
                                        min-height: 240px;     
                                }
                       }
                }
    .wrapper {
                margin-bottom: 10px;
                border-radius: 5px;
                overflow: hidden;

                .img_div{
                        display: flex;
                        width: 100%;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                }

                .swiper-img{
                        width: 160%;
                }
        }
</style>



// WEBPACK FOOTER //
// src/components/move/banner.vue